import httpClient from 'utils/httpClient';

export const companyApi = {
  async fillInExampleData() {
    const url = '/company/example_data';

    return await httpClient.post(url);
  },
};
